import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: apiUrl,
  timeout: 600000, // 10 minutes for large file uploads
});

console.log('API instance created with baseURL:', api.defaults.baseURL);

export default api;
